import { FormCrudDataGridProps } from "src/components/common/dataGrid/crud/FormCrudDataGrid";
import { useAsyncFetch } from "src/utils/async/asyncFetch.ts";
import { ControlledAsyncFormCrudDataGrid } from "./ControlledAsyncFormCrudDataGrid";
import { RefreshableElementProps, setRefreshRefValue } from "src/utils/useRefreshRef.ts";

export interface AsyncFormCrudDataGridProps<RowData extends object>
	extends Omit<FormCrudDataGridProps<RowData>, "rows" | "refreshData">,
		RefreshableElementProps {
	fetchData: () => Promise<RowData[]>;
}

export const AsyncFormCrudDataGrid = <RowData extends object>({
	refreshRef,
	fetchData,
	...other
}: AsyncFormCrudDataGridProps<RowData>) => {
	const [asyncRows, refresh] = useAsyncFetch(fetchData);
	setRefreshRefValue(refreshRef, () => refresh());
	return <ControlledAsyncFormCrudDataGrid rowsAsync={asyncRows} refreshData={refresh} {...other} />;
};
